import React, { forwardRef } from "react";
import styles from "./style.module.css";
import Spinner from "../spinner";

export type ButtonVariant = "primary" | "secondary" | "tertiary";

interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  label: string;
  href: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: ButtonVariant;
}

const ButtonLink = forwardRef<HTMLAnchorElement, ButtonProps>((props, ref) => {
  const {
    label,
    href,
    variant = "primary",
    onClick,
    disabled = false,
    className = "",
    loading = false,
    ...restProps
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled || loading) {
      event.preventDefault();
      return;
    }
    
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <a
      ref={ref}
      rel="noreferrer"
      href={disabled || loading ? undefined : href}
      className={`${styles.button} ${styles[`button--${variant}`]} ${
        disabled ? styles["button--disabled"] : ""
      } ${className}`}
      aria-disabled={disabled || loading}
      onClick={handleClick}
      target="_blank"
      {...restProps}
    >
      <span className={styles.button__label}>
        {loading ? (
          <Spinner color={variant === "primary" ? "black" : "white"} />
        ) : (
          label
        )}
      </span>
    </a>
  );
});

ButtonLink.displayName = "ButtonLink";

export default ButtonLink;